import {
  ItemTagsColors,
  ItemTagsContent,
  MarketableClassification,
} from '@lojinha/palantir'

export const itemsMock = [
  {
    id: '5b7c39029d041700141052f2',
    name: 'Creme de Mandioquinha',
    mainProduct: 'Lorem Ipsum',
    description: 'Lorem Ipsum',
    imageUrl:
      'website/images/photos-original/hamburguer-de-salmao--batata-rustica-com-alecrim--brocolis-no-vapor-320g-1591911349383.jpg',
    kind: 'PRODUCT',
    classification: MarketableClassification.Product,
    isAvailable: true,
    sellingStatus: 'SELLING',
    itemTags: {
      totalCount: 3,
      nodes: [
        {
          content: ItemTagsContent.IsNew,
          colorPalette: ItemTagsColors.New,
        },
        {
          content: ItemTagsContent.IsBestSeller,
          colorPalette: ItemTagsColors.Promotion,
        },
        {
          content: ItemTagsContent.Eggs,
          colorPalette: ItemTagsColors.Default,
        },
      ],
    },
    seo: { __typename: 'ProductSeo', url: 'creme-de-mandioquinha-congelado/p' },
    imageAriaLabel:
      'A refeição Batata rústica com alecrim e brócolis no vapor, está arrumada em um prato branco, sob o prato tem um jogo de mesa redondo na cor laranja e uma mesa de madeira branca.',
    price: 1090,
    priceFrom: 1250,
    sku: 'S910',
    unit: 'g',
    weight: 350,
  },
  {
    id: '5b7c39029d041700141052f2',
    name: 'Creme de Mandioquinha',
    mainProduct: 'Lorem Ipsum',
    description: 'Lorem Ipsum',
    imageUrl:
      'website/images/photos-original/hamburguer-de-salmao--batata-rustica-com-alecrim--brocolis-no-vapor-320g-1591911349383.jpg',
    kind: 'PRODUCT',
    classification: MarketableClassification.Product,
    isAvailable: true,
    sellingStatus: 'SELLING',
    itemTags: {
      totalCount: 3,
      nodes: [
        {
          content: ItemTagsContent.IsNew,
          colorPalette: ItemTagsColors.New,
        },
        {
          content: ItemTagsContent.IsBestSeller,
          colorPalette: ItemTagsColors.Promotion,
        },
        {
          content: ItemTagsContent.Eggs,
          colorPalette: ItemTagsColors.Default,
        },
      ],
    },
    seo: { __typename: 'ProductSeo', url: 'creme-de-mandioquinha-congelado/p' },
    imageAriaLabel:
      'A refeição Batata rústica com alecrim e brócolis no vapor, está arrumada em um prato branco, sob o prato tem um jogo de mesa redondo na cor laranja e uma mesa de madeira branca.',
    price: 1090,
    priceFrom: 1250,
    sku: 'S910',
    unit: 'g',
    weight: 350,
  },
  {
    id: '5b7c39029d041700141052f2',
    name: 'Creme de Mandioquinha',
    mainProduct: 'Lorem Ipsum',
    description: 'Lorem Ipsum',
    imageUrl:
      'website/images/photos-original/hamburguer-de-salmao--batata-rustica-com-alecrim--brocolis-no-vapor-320g-1591911349383.jpg',
    kind: 'PRODUCT',
    classification: MarketableClassification.Product,
    isAvailable: true,
    sellingStatus: 'SELLING',
    itemTags: {
      totalCount: 3,
      nodes: [
        {
          content: ItemTagsContent.IsNew,
          colorPalette: ItemTagsColors.New,
        },
        {
          content: ItemTagsContent.IsBestSeller,
          colorPalette: ItemTagsColors.Promotion,
        },
        {
          content: ItemTagsContent.Eggs,
          colorPalette: ItemTagsColors.Default,
        },
      ],
    },
    seo: { __typename: 'ProductSeo', url: 'creme-de-mandioquinha-congelado/p' },
    imageAriaLabel:
      'A refeição Batata rústica com alecrim e brócolis no vapor, está arrumada em um prato branco, sob o prato tem um jogo de mesa redondo na cor laranja e uma mesa de madeira branca.',
    price: 1090,
    priceFrom: 1250,
    sku: 'S910',
    unit: 'g',
    weight: 350,
  },
  {
    id: '5b7c39029d041700141052f2',
    name: 'Creme de Mandioquinha',
    mainProduct: 'Lorem Ipsum',
    description: 'Lorem Ipsum',
    imageUrl:
      'website/images/photos-original/hamburguer-de-salmao--batata-rustica-com-alecrim--brocolis-no-vapor-320g-1591911349383.jpg',
    kind: 'PRODUCT',
    classification: MarketableClassification.Product,
    isAvailable: true,
    sellingStatus: 'SELLING',
    itemTags: {
      totalCount: 3,
      nodes: [
        {
          content: ItemTagsContent.IsNew,
          colorPalette: ItemTagsColors.New,
        },
        {
          content: ItemTagsContent.IsBestSeller,
          colorPalette: ItemTagsColors.Promotion,
        },
        {
          content: ItemTagsContent.Eggs,
          colorPalette: ItemTagsColors.Default,
        },
      ],
    },
    seo: { __typename: 'ProductSeo', url: 'creme-de-mandioquinha-congelado/p' },
    imageAriaLabel:
      'A refeição Batata rústica com alecrim e brócolis no vapor, está arrumada em um prato branco, sob o prato tem um jogo de mesa redondo na cor laranja e uma mesa de madeira branca.',
    price: 1090,
    priceFrom: 1250,
    sku: 'S910',
    unit: 'g',
    weight: 350,
  },
]
